import React from "react";
import SimpleTable from "./SimpleTable";
import { StatusLabel } from "./StatusLabel";
import UploadReportButton from "./UploadReportButton";
import SafeExternalLink from "../lithic/SafeExternalLink";
import Time from "../lithic/Moment";

export function FurnishmentReportsTable({ reports = [], onReportUpload }) {
  const bureauReports = reports.reduce(
    (bureaus, report) => {
      return {
        ...bureaus,
        [report.bureau]: [...bureaus[report.bureau], report]
      };
    },
    { experian: [], equifax: [], transunion: [] }
  );

  function showTimeComponent(date) {
    return date ? (
      <Time formatExact={"MMM Do YYYY, h:mm:ss"}>{date}</Time>
    ) : null;
  }

  function showUploadButton(report) {
    if (!["pending", "failed"].includes(report.status)) return null;
    const label = report.status === "failed" ? "Retry" : "Upload";
    return (
      <UploadReportButton
        id={report.id}
        onClick={onReportUpload}
        label={label}
      />
    );
  }

  return (
    <SimpleTable
      headers={[
        "ID",
        "Bureau",
        "Status",
        "Created At",
        "Uploaded At",
        "Download",
        ""
      ]}
      rows={Object.values(bureauReports).flat()}
      toCells={(report) => [
        report.id,
        report.bureau,
        <StatusLabel status={report.status} />,
        showTimeComponent(report.createdAt),
        showTimeComponent(report.uploadedAt),
        <SafeExternalLink href={report.url} key={report.id}>
          Link
        </SafeExternalLink>,
        showUploadButton(report)
      ]}
    />
  );
}
